<template>
    <ul class="review-gallery clearfix d-flex">
        <li v-for="(image, index) in galleryImages" :key="index" @click="() => show(index)" data-aos="fade-down">
            <a href="javascript:void(0)" data-fancybox="gallery">
                <img class="img-fluid" alt="Image" :src="require(`@/assets/img/gallery/${image.src}`)">
            </a>
        </li>
    </ul>

    <vue-easy-lightbox :visible="visible" :index="index" :imgs="galleryImages.map((image) => ({
        src: require(`@/assets/img/gallery/${image.src}`),
    }))" @hide="visible = false" @on-prev="handlePrev" @on-next="handleNext">
    </vue-easy-lightbox>
</template>

<script>
import VueEasyLightbox from "vue-easy-lightbox";
export default {
    components: {
        VueEasyLightbox,
    },
    data() {
        return {
            title: "Gallery",
            text: "Pages",
            text1: "Gallery",
            visible: false,
            index: 0,
            galleryImages: [
                {
                    src: "gallery-thumb-01.jpg",
                },
                {
                    src: "gallery-thumb-02.jpg",
                },
                {
                    src: "gallery-thumb-03.jpg",
                },
                {
                    src: "gallery-thumb-04.jpg",
                },
                {
                    src: "gallery-thumb-05.jpg",
                },
            ],
        };
    },
    methods: {
        show(index) {
            this.index = index;
            this.visible = true;
        },
        handlePrev(oldIndex, newIndex) { },
        handleNext(oldIndex, newIndex) { },
    },
};
</script>